document.addEventListener('DOMContentLoaded', () => {
  const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.getElementById('MobileMenu');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const willOpen = mobileMenu.hasAttribute('hidden');
      mobileMenu.toggleAttribute('hidden');
      mobileToggle.setAttribute('aria-expanded', String(willOpen));
    });

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        mobileMenu.setAttribute('hidden', '');
        mobileToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  document.querySelectorAll('.site-header__dropdown').forEach((details) => {
    const summary = details.querySelector('summary');

    if (!summary) return;

    document.addEventListener('click', (event) => {
      if (details.contains(event.target)) return;
      details.removeAttribute('open');
    });
  });
});
